export const UNIT_PROFILE_NOT_FOUND = 'UNIT_PROFILE_NOT_FOUND';
export const UNIT_PROFILE_DUPLICATE_CODE = 'UNIT_PROFILE_DUPLICATE_CODE';
export const UNIT_PROFILE_SCOPE_MISMATCH = 'UNIT_PROFILE_SCOPE_MISMATCH';
export const UNIT_PROFILE_TEMPLATE_INVALID = 'UNIT_PROFILE_TEMPLATE_INVALID';
export const UNIT_PROFILE_VALIDATION_FAILED = 'UNIT_PROFILE_VALIDATION_FAILED';
export const UNIT_PROFILE_STRUCTURAL_EDIT_NOT_ALLOWED =
  'UNIT_PROFILE_STRUCTURAL_EDIT_NOT_ALLOWED';
export const UNIT_PROFILE_TARE_PROFILE_INVALID = 'UNIT_PROFILE_TARE_PROFILE_INVALID';
export const UNIT_PROFILE_MANAGED_IN_WEB = 'UNIT_PROFILE_MANAGED_IN_WEB';

export const unitProfileErrorCodes = [
  UNIT_PROFILE_NOT_FOUND,
  UNIT_PROFILE_DUPLICATE_CODE,
  UNIT_PROFILE_SCOPE_MISMATCH,
  UNIT_PROFILE_TEMPLATE_INVALID,
  UNIT_PROFILE_VALIDATION_FAILED,
  UNIT_PROFILE_STRUCTURAL_EDIT_NOT_ALLOWED,
  UNIT_PROFILE_TARE_PROFILE_INVALID,
  UNIT_PROFILE_MANAGED_IN_WEB,
] as const;

export type UnitProfileErrorCode = (typeof unitProfileErrorCodes)[number];
